/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LocalizationComponent from '../../Localization/LocalizationComponent';
import ComponentBase from '../ComponentBase';
import InjectableComponent from './ComponentReference/InjectableComponent';
import { ReferenceGroup } from './ComponentReference/ReferenceGroup';
import ObservableStringComponent from './Observable/ObservableStringComponent';

/** Tracks the elapsed time since the game was launched. */
@cc._decorator.ccclass
export class SessionTimeManager extends ComponentBase
{
    /** @hidden */
    private _sessionTimeObservableRef: InjectableComponent<ObservableStringComponent> =
        new InjectableComponent<ObservableStringComponent>(ReferenceGroup.MainGame, "SessionTime.String");
    /** Accessor for the observable session time string. */
    public get SessionTimeObservable(): ObservableStringComponent { return this._sessionTimeObservableRef.Value; }

    private _localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    /** Local time at start of session. */
    private _localStartTime: number = 0;
    /** How many complete seconds have elapsed since game start. */
    private _elapsedTimeSeconds: number = 0;
    /** Options to use when formatting the hours, minutes, and seconds values. */
    private _formatOptions: Intl.NumberFormatOptions = { minimumIntegerDigits: 2, maximumFractionDigits: 0 };

    /** @hidden */
    protected setContexts(): void
    {
        this._sessionTimeObservableRef.SetContext(ObservableStringComponent);
        this._localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected update(dt: number): void
    {
        if (!this._localStartTime) { this._localStartTime = new Date().getTime(); }
        const startingSeconds: number = this._elapsedTimeSeconds;
        this._elapsedTimeSeconds = Math.floor((new Date().getTime() - this._localStartTime) / 1000);

        if (this._elapsedTimeSeconds === startingSeconds) { return; }

        this._localRef.WithValue(local =>
        {
            const seconds: number = this._elapsedTimeSeconds % 60;
            const minutes: number = Math.floor(this._elapsedTimeSeconds / 60) % 60;
            const hours: number = Math.floor(Math.floor(this._elapsedTimeSeconds / 60) / 60);

            this.SessionTimeObservable.Value =
            [
                hours.toLocaleString(local.CultureKey, this._formatOptions),
                minutes.toLocaleString(local.CultureKey, this._formatOptions),
                seconds.toLocaleString(local.CultureKey, this._formatOptions)
            ].join(":");
        });
    }
}
